<div class="region-rule">
  <p class="rule-description">
    Enable the feature for specific geographic regions. The feature will be enabled for users in these regions.
  </p>

  <div class="common-regions">
    <h4>Common Regions</h4>
    <div class="region-chip-container">
      <div
        *ngFor="let region of commonItems"
        class="region-chip"
        [class.selected]="isItemSelected(region)"
        (click)="toggleItem(region)"
      >
        {{ region }}
      </div>
    </div>
  </div>

  <div class="region-input-container">
    <label for="region-input">Add Custom Region:</label>
    <div class="input-group">
      <input
        type="text"
        id="region-input"
        [formControl]="newItemControl"
        placeholder="e.g., asia-east"
        (keydown.enter)="onInputKeydown($event)"
      />
      <button mat-flat-button color="primary" type="button" class="fx--ml-sm" (click)="addItem()">Add</button>
    </div>
    <div *ngIf="error" class="error-message">{{ error }}</div>
  </div>

  <div class="regions-container" *ngIf="items.length > 0">
    <div class="regions-header">
      <h4>Selected Regions ({{ items.length }})</h4>
      <button mat-button color="primary" type="button" (click)="clearItems()">Clear All</button>
    </div>

    <ul class="regions-list">
      <li *ngFor="let region of items; let i = index" class="region-item">
        <span class="region-name">{{ region }}</span>
        <button mat-button color="primary" type="button" (click)="removeItem(i)" aria-label="Remove">×</button>
      </li>
    </ul>
  </div>

  <div class="empty-state" *ngIf="items.length === 0">
    <p>No regions selected. This feature will not be enabled for any region.</p>
  </div>
</div>
